import AppRoutings from './routings/Index';

function App() {
  return <AppRoutings />;
}

export default App;
